import { Form, Select } from 'antd';
import { useState } from 'react';

import { CascaderTplType, OptionInterface } from '../types/tplTypes';

function getValues(children: CascaderTplType, res: Array<string> = []) {
  const { id: value, children: child } = children;
  res.push(value);
  if (child) {
    getValues(child, res);
  } else {
    return res;
  }
}

export const CascaderTpl = ({
  data,
  form,
}: {
  data: CascaderTplType;
  form: any;
}) => {
  const {
    valueField: key = 'key',
    labelField: label = 'value',
    children,
    options = [] as Array<OptionInterface>,
    disabled,
    afterChange,
    disabledWhenEmpty = true,
  } = data;
  const [childrenData, setChildrenData] = useState(children);

  const onChange = (value: string) => {
    if (!children) {
      return;
    }
    const ids = getValues(children) as Array<string>;

    form.resetFields(ids);
    const filter = options.find((item) => item[key] === value);

    const subOptions = (
      filter ? filter.children || [] : []
    ) as Array<OptionInterface>;

    children.options = subOptions;
    if (!value) {
      children.disabled = false;
    } else if (!subOptions.length && disabledWhenEmpty) {
      children.disabled = true;
    } else {
      children.disabled = false;
    }
    setChildrenData({ ...children });

    if (afterChange) {
      afterChange(form);
    }
  };
  return (
    <>
      <Form.Item
        name={data.id}
        label={data?.label}
        {...(data.formItemProps || {})}
      >
        <Select
          allowClear
          placeholder={data.placeholder}
          showSearch
          onChange={onChange}
          disabled={disabled}
          {...(data.componentProps || {})}
        >
          {options.map((item: OptionInterface) => {
            return (
              <Select.Option key={item[key]} value={item[key]}>
                {item[label]}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
      {children && (
        <CascaderTpl data={childrenData as CascaderTplType} form={form} />
      )}
    </>
  );
};
